import { CGNavigationItem, CGNavigationCollections, CGSecondaryNavigationOptions } from 'types/cardgift';
// import { isMobileOrTablet } from 'utilities/userAgent';

// let exploreLabel: 'Explore Gift Cards' | 'Explore' = 'Explore Gift Cards';
// let redeemLabel: 'Redeem a Gift Card' | 'Redeem' = 'Redeem a Gift Card';
// let forLabel: 'For Business' | 'Business' = 'For Business';

// if (isMobileOrTablet()) {
//   exploreLabel = 'Explore';
//   redeemLabel = 'Redeem';
//   forLabel = 'Business';
// }

export const navigationCollectionHandle: string = 'best-sellers';
export const navigationData: CGNavigationItem[] = [
  {
    label: 'Shop Gift Cards',
    mobileLabel: 'Shop',
    path: '/cards/all',
  },
  {
    label: 'Redeem a Gift Card',
    mobileLabel: 'Redeem',
    path: '/redeem',
  },
  {
    label: 'For Business',
    mobileLabel: 'Business',
    path: '/landing/corporate',
  },
];

// To Do: may need to update path
export const shopByCardType: CGNavigationCollections[] = [
  {
    title: 'Physical Cards',
    description: 'Physical gift cards delivered by mail',
    path: '/landing/physical-cards',
  },
  {
    title: 'eGift Cards',
    description: 'Digital gift cards delivered via email or SMS',
    path: '/landing/e-gift-voucher',
  },
  {
    title: 'Mastercard Gift Cards',
    description: 'Use anywhere Mastercard is accepted',
    path: '/landing/mastercard',
  },
  {
    title: 'eftpos Gift Cards',
    description: 'Use anywhere eftpos is accepted around Australia',
    path: '/landing/eftpos-gift-card',
  },
  {
    title: 'Card.Gift Cards',
    description: 'Design your own gift card image instantly',
    path: '/landing/card-gift-credit',
  },
  {
    title: 'Multi-Choice Gift Cards',
    description: 'Featuring a range of the best brands on the one card',
    path: '/landing/multi-choice-cards',
  },
];
export const shopByCategory: CGNavigationCollections[] = [
  {
    title: 'Gifts for Baby',
    path: '/landing/gifts-for-baby',
  },
  {
    title: 'Gifts for Travel',
    path: '/landing/gifts-for-travel',
  },
  {
    title: 'Gifts for Beauty',
    path: '/landing/gifts-for-beauty',
  },
  {
    title: 'Gifts for Wedding',
    path: '/landing/gifts-for-wedding',
  },
  {
    title: 'Gifts for Birthday',
    path: '/landing/gifts-for-birthday',
  },
  {
    title: 'Gifts for Staff',
    path: '/landing/gifts-for-staff',
  },
  {
    title: 'Gifts for Thanks',
    path: '/landing/gifts-for-thanks',
  },
  {
    title: 'Gifts for Couples',
    path: '/landing/gifts-for-couples',
  },
  {
    title: 'Gifts for Christmas',
    path: '/landing/gifts-for-christmas',
  },
];
export const ShopByCollection: CGNavigationCollections[] = [
  {
    title: 'Featured',
    path: '/landing/our-top-picks',
  },
  {
    title: 'Major Retailers',
    path: '/landing/big-brands-on-show',
  },
  {
    title: 'Food & Drink',
    path: '/landing/serve-up-a-great-gift',
  },
  {
    title: 'Technology & Gaming',
    path: '/landing/one-for-the-tech-heads',
  },
  {
    title: 'Home',
    path: '/landing/home-is-where-the-heart-is',
  },
  {
    title: 'Fashion',
    path: '/landing/shop-til-you-drop',
  },
  {
    title: 'Sports & Fitness',
    path: '/landing/keeping-it-active',
  },
  {
    title: 'Entertainment & Travel',
    path: '/landing/let-me-entertain-you',
  },
  {
    title: 'Kids & Teens',
    path: '/landing/fun-and-games',
  },
];

export const secondaryNavigationOptions: CGSecondaryNavigationOptions[] = [
  {
    title: 'Shop by Card Type',
    items: shopByCardType,
    isFirstItem: true,
  },
  {
    title: 'Featured Collections',
    items: shopByCategory,
  },
  {
    title: 'Shop by Category',
    items: ShopByCollection,
  },
];
